<template>
  <div>
    <v-stepper v-model="step" class="ui-stepper" non-linear elevation="0">
      <!-- Barra de pasos -->
      <v-stepper-header class="ui-stepper-header elevation-0">
        <v-stepper-step step="1" :complete="step > 1" color="secondary" edit-icon="mdi-check">
          <span class="step-label">Datos generales</span>
        </v-stepper-step>
        <v-divider class="step-divider"></v-divider>
        <v-stepper-step step="2" :complete="step > 2" color="secondary" edit-icon="mdi-check">
          <span class="step-label">Médico</span>
        </v-stepper-step>
        <v-divider class="step-divider"></v-divider>
        <v-stepper-step step="3" :complete="step > 3" color="secondary" edit-icon="mdi-check">
          <span class="step-label">Armería</span>
        </v-stepper-step>
        <v-divider class="step-divider"></v-divider>
        <v-stepper-step step="4" :complete="step > 4" color="secondary" edit-icon="mdi-check">
          <span class="step-label">Academia</span>
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <!-- STEP 1: Datos generales -->
        <v-stepper-content step="1" class="ui-step-content">
          <div class="step-section-title">
            <v-icon color="secondary" class="mr-2">mdi-clipboard-text-outline</v-icon>
            Datos generales del resultado
          </div>
          <v-row dense class="mt-3">
            <v-col cols="12">
              <v-text-field
                class="modern-input"
                v-model="editado.numFolio"
                dense
                filled
                rounded
                color="secondary"
                background-color="transparent"
                label="Número de folio"
                prepend-inner-icon="mdi-pound"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                class="modern-input"
                v-model="editado.resultado"
                dense
                filled
                rounded
                color="secondary"
                background-color="transparent"
                :items="resultados"
                item-value="title"
                item-text="title"
                item-color="secondary"
                prepend-inner-icon="mdi-check-decagram-outline"
              >
                <template v-slot:label>Resultado <span class="red--text">*</span></template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <div class="date-label mb-1">
                <v-icon color="secondary" small class="mr-1">mdi-calendar</v-icon>
                Fecha de emisión C3 <span class="red--text">*</span>
              </div>
              <v-date-picker
                class="modern-date-picker"
                v-model="editado.fechaVigenciaEvaluacionC3"
                locale="es"
                color="secondary"
                no-title
                full-width
              ></v-date-picker>
            </v-col>
            <v-col cols="12" class="mt-2">
              <div class="obs-field-label mb-1">
                <v-icon color="secondary" small class="mr-1">mdi-text-box-outline</v-icon>
                Observaciones generales
              </div>
              <v-textarea
                class="modern-textarea"
                v-model="editado.observacionesGenerales"
                rows="6"
                no-resize
                color="secondary"
                background-color="transparent"
                placeholder="Describe las observaciones generales del resultado C3..."
                filled
                rounded
                dense
                counter="1000"
                maxlength="1000"
              ></v-textarea>
            </v-col>
          </v-row>
          <div class="step-actions mt-4">
            <div></div>
            <v-btn
              color="secondary"
              class="btn-siguiente primary--text"
              :disabled="!editado.resultado || !editado.fechaVigenciaEvaluacionC3"
              @click="step = 2"
            >
              Siguiente
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-stepper-content>

        <!-- STEP 2: Observaciones médicas -->
        <v-stepper-content step="2" class="ui-step-content">
          <div class="step-section-title">
            <v-icon color="secondary" class="mr-2">mdi-stethoscope</v-icon>
            Médico
          </div>
          <p class="step-description mt-2">
            Registra las observaciones de carácter médico derivadas de la evaluación C3. Incluye hallazgos relevantes,
            condiciones identificadas o cualquier nota clínica pertinente al proceso de certificación.
          </p>
          <v-textarea
            class="modern-textarea mt-3"
            v-model="editado.observacionesMedicas"
            rows="12"
            no-resize
            color="secondary"
            background-color="transparent"
            placeholder="Detalla las observaciones médicas aquí..."
            filled
            rounded
            dense
            counter="1000"
            maxlength="1000"
          ></v-textarea>
          <div class="step-actions mt-4">
            <v-btn text class="btn-regresar" @click="step = 1">
              <v-icon left small>mdi-arrow-left</v-icon>
              Anterior
            </v-btn>
            <v-btn color="secondary" class="btn-siguiente primary--text" @click="step = 3">
              Siguiente
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-stepper-content>

        <!-- STEP 3: Observaciones adicionales A -->
        <v-stepper-content step="3" class="ui-step-content">
          <div class="step-section-title">
            <v-icon color="secondary" class="mr-2">mdi-note-text-outline</v-icon>
            Armería
          </div>
          <p class="step-description mt-2">
            Espacio para observaciones complementarias al resultado C3. Puede incluir aspectos psicológicos,
            situacionales o de otra índole que se consideren relevantes para el expediente del evaluado.
          </p>
          <v-textarea
            class="modern-textarea mt-3"
            v-model="editado.observacionesAdicionalesA"
            rows="12"
            no-resize
            color="secondary"
            background-color="transparent"
            placeholder="Registra aquí las observaciones adicionales A..."
            filled
            rounded
            dense
            counter="1000"
            maxlength="1000"
          ></v-textarea>
          <div class="step-actions mt-4">
            <v-btn text class="btn-regresar" @click="step = 2">
              <v-icon left small>mdi-arrow-left</v-icon>
              Anterior
            </v-btn>
            <v-btn color="secondary" class="btn-siguiente primary--text" @click="step = 4">
              Siguiente
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-stepper-content>

        <!-- STEP 4: Observaciones adicionales B + resumen + guardar -->
        <v-stepper-content step="4" class="ui-step-content">
          <div class="step-section-title">
            <v-icon color="secondary" class="mr-2">mdi-note-plus-outline</v-icon>
            Academia
          </div>
          <p class="step-description mt-2">
            Última sección de observaciones. Utiliza este espacio para registrar cualquier información adicional que
            complemente el expediente de resultado C3 del evaluado.
          </p>
          <v-textarea
            class="modern-textarea mt-3"
            v-model="editado.observacionesAdicionalesB"
            rows="8"
            no-resize
            color="secondary"
            background-color="transparent"
            placeholder="Registra aquí las observaciones adicionales B..."
            filled
            rounded
            dense
            counter="1000"
            maxlength="1000"
          ></v-textarea>

          <!-- Resumen del registro -->
          <div class="summary-card mt-4">
            <div class="summary-title mb-3">
              <v-icon color="secondary" small class="mr-1">mdi-eye-outline</v-icon>
              Resumen del registro
            </div>
            <div class="summary-row">
              <span class="summary-label">Folio:</span>
              <span class="summary-value">{{ editado.numFolio || '—' }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Resultado:</span>
              <v-chip x-small :color="editado.resultado === 'Aprobado' ? 'success' : 'warning'" class="ml-1">
                {{ editado.resultado || '—' }}
              </v-chip>
            </div>
            <div class="summary-row">
              <span class="summary-label">Fecha de emisión:</span>
              <span class="summary-value">{{ editado.fechaVigenciaEvaluacionC3 || '—' }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Obs. generales:</span>
              <span class="summary-value summary-preview">{{
                editado.observacionesGenerales
                  ? editado.observacionesGenerales.substring(0, 60) +
                    (editado.observacionesGenerales.length > 60 ? '…' : '')
                  : '—'
              }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Médico:</span>
              <span class="summary-value summary-preview">{{
                editado.observacionesMedicas
                  ? editado.observacionesMedicas.substring(0, 60) +
                    (editado.observacionesMedicas.length > 60 ? '…' : '')
                  : '—'
              }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Armería:</span>
              <span class="summary-value summary-preview">{{
                editado.observacionesAdicionalesA
                  ? editado.observacionesAdicionalesA.substring(0, 60) +
                    (editado.observacionesAdicionalesA.length > 60 ? '…' : '')
                  : '—'
              }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Academia:</span>
              <span class="summary-value summary-preview">{{
                editado.observacionesAdicionalesB
                  ? editado.observacionesAdicionalesB.substring(0, 60) +
                    (editado.observacionesAdicionalesB.length > 60 ? '…' : '')
                  : '—'
              }}</span>
            </div>
          </div>

          <div class="step-actions mt-5">
            <v-btn text class="btn-regresar" @click="step = 3">
              <v-icon left small>mdi-arrow-left</v-icon>
              Anterior
            </v-btn>
            <v-btn
              color="secondary"
              class="btn-guardar primary--text"
              :loading="loading"
              :disabled="!editado.resultado || !editado.fechaVigenciaEvaluacionC3 || loading"
              @click="guardar"
            >
              <v-icon left small>mdi-content-save-outline</v-icon>
              Guardar cambios
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import DateAdapter from '@/utils/DateAdapter'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import moment from 'moment'

export default {
  props: {
    resultadoC3: {
      type: Object,
      required: true,
    },
    idPersonal: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      step: 1,
      editado: { ...this.resultadoC3 },
      loading: false,
      resultados: [
        { id: 1, title: 'Aprobado' },
        { id: 2, title: 'No aprobado' },
        { id: 3, title: 'No cubre perfil' },
        { id: 4, title: 'Sí cubre perfil' },
      ],
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },
  watch: {
    resultadoC3: {
      handler(val) {
        let fecha = null
        if (val.fechaVigenciaEvaluacionC3) {
          const fechaNormalizada = val.fechaVigenciaEvaluacionC3.replace('a. m.', 'AM').replace('p. m.', 'PM')
          const parsed = moment(fechaNormalizada, 'DD/MM/YYYY hh:mm:ss A')
          if (parsed.isValid()) {
            fecha = parsed.format('YYYY-MM-DD')
          } else {
            console.warn('[EditarResultadoC3] fecha inválida recibida:', val.fechaVigenciaEvaluacionC3)
          }
        }
        this.editado = { ...val, fechaVigenciaEvaluacionC3: fecha }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions('resultadosPersonalesC3', ['updateResultado']),
    ...mapActions('dialog', ['closeDialog']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('notificaciones', ['createNotification']),

    async guardar() {
      this.loading = true
      const fechaFormateada = this.editado.fechaVigenciaEvaluacionC3
        ? moment(this.editado.fechaVigenciaEvaluacionC3, 'YYYY-MM-DD').format('DD/MM/YYYY hh:mm:ss A')
        : null

      try {
        await this.updateResultado({
          idPersonal: this.idPersonal,
          idResultado: this.editado.idResultado,
          resultado: {
            resultado: this.editado.resultado,
            fechaVigenciaEvaluacionC3: fechaFormateada,
            numFolio: this.editado.numFolio,
            observacionesGenerales: this.editado.observacionesGenerales,
            observacionesMedicas: this.editado.observacionesMedicas,
            observacionesAdicionalesA: this.editado.observacionesAdicionalesA,
            observacionesAdicionalesB: this.editado.observacionesAdicionalesB,
          },
        })
        const notificacionOk = await this.sendNotification()
        if (notificacionOk) {
          this.SET_SNACKBAR_MESSAGE('Resultado C3 actualizado correctamente.')
        }
        this.closeDialog()
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al actualizar el resultado C3. Intenta de nuevo.')
      } finally {
        this.loading = false
      }
    },

    async sendNotification() {
      try {
        const notification = new NotificationFactory(Notificacion).createNotification(
          NOTIFICATION_TYPES.EMISION_RESULTADO_C3,
          {
            responsable: Number(localStorage.getItem('idPersonal')),
            afectado: this.idPersonal,
            nombrePersonal: this.getFullName(this.personal),
            resultado: this.editado.resultado,
            fechaVigencia: new DateAdapter(this.editado.fechaVigenciaEvaluacionC3, 'YYYY-MM-DD').toUiSupportedFormat(),
          }
        )
        await this.createNotification(notification)
        return true
      } catch (error) {
        console.error('[EditarResultadoC3] sendNotification failed:', error)
        this.SET_SNACKBAR_MESSAGE('Resultado actualizado, pero ocurrió un error al notificar.')
        return false
      }
    },
  },
}
</script>

<style scoped>
/* ── Stepper contenedor ── */
::v-deep .ui-stepper {
  background: rgba(30, 24, 10, 0.55) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.18);
  border-radius: 20px;
  overflow: hidden;
}

/* ── Header de pasos ── */
::v-deep .ui-stepper-header {
  background: rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.06) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.15);
  flex-wrap: wrap;
  padding: 8px 0;
}

::v-deep .v-stepper__step__step {
  font-size: 0.75rem !important;
}

::v-deep .v-stepper__label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-stepper__step--active .v-stepper__label {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
}

::v-deep .v-stepper__step--complete .v-stepper__label {
  color: var(--v-secondary-base) !important;
}

.step-label {
  font-size: 0.72rem;
  white-space: nowrap;
}

.step-divider {
  border-color: rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.2) !important;
}

/* ── Contenido del step ── */
::v-deep .ui-step-content {
  padding: 28px 28px 16px !important;
}

.step-section-title {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;
  color: #e0e0e0;
  letter-spacing: 0.3px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.12);
}

.step-description {
  font-size: 0.85rem;
  color: rgba(224, 224, 224, 0.6);
  line-height: 1.6;
  margin: 0;
}

/* ── Labels ── */
.date-label,
.obs-field-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: rgba(224, 224, 224, 0.75);
  display: flex;
  align-items: center;
}

/* ── Inputs ── */
::v-deep .modern-input .v-input__slot,
::v-deep .modern-textarea .v-input__slot {
  background: rgba(10, 10, 22, 0.4) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.2) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: border-color 0.25s ease, box-shadow 0.25s ease !important;
}

::v-deep .modern-input .v-input__slot:hover,
::v-deep .modern-textarea .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.42) !important;
}

::v-deep .modern-input.v-input--is-focused .v-input__slot,
::v-deep .modern-textarea.v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.12) !important;
}

::v-deep .modern-input .v-label,
::v-deep .modern-input input,
::v-deep .modern-input .v-select__selection,
::v-deep .modern-textarea .v-label,
::v-deep .modern-textarea textarea {
  color: #e0e0e0 !important;
}

::v-deep .modern-textarea .v-counter {
  color: rgba(224, 224, 224, 0.4) !important;
  font-size: 0.72rem;
}

::v-deep .modern-textarea textarea::placeholder {
  color: rgba(224, 224, 224, 0.3) !important;
}

/* ── Date picker ── */
::v-deep .modern-date-picker {
  border: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.18);
  border-radius: 14px;
  overflow: hidden;
  background: rgba(10, 10, 22, 0.3);
}

::v-deep .modern-date-picker .v-date-picker-header,
::v-deep .modern-date-picker .v-date-picker-table {
  background: transparent !important;
}

/* ── Acciones del step ── */
.step-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.1);
}

.btn-regresar {
  color: rgba(224, 224, 224, 0.6) !important;
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  border-radius: 10px !important;
}

.btn-regresar:hover {
  color: #e0e0e0 !important;
}

.btn-siguiente,
.btn-guardar {
  text-transform: none !important;
  font-weight: 700 !important;
  letter-spacing: 0.2px !important;
  border-radius: 12px !important;
  padding: 0 20px !important;
  background: linear-gradient(
    135deg,
    var(--v-secondary-base) 0%,
    var(--v-secondary-lighten1, var(--v-secondary-base)) 100%
  ) !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.25) !important;
  transition: box-shadow 0.3s ease, transform 0.2s ease !important;
}

.btn-siguiente:hover:not(:disabled),
.btn-guardar:hover:not(:disabled) {
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.38) !important;
  transform: translateY(-1px);
}

/* ── Resumen ── */
.summary-card {
  background: rgba(10, 10, 22, 0.35);
  border: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.15);
  border-radius: 14px;
  padding: 16px 20px;
}

.summary-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: rgba(224, 224, 224, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.8px;
  display: flex;
  align-items: center;
}

.summary-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb, 247, 183, 49), 0.07);
  font-size: 0.85rem;
}

.summary-row:last-child {
  border-bottom: none;
}

.summary-label {
  color: rgba(224, 224, 224, 0.5);
  min-width: 110px;
  font-size: 0.78rem;
  flex-shrink: 0;
}

.summary-value {
  color: #e0e0e0;
  font-weight: 500;
}

.summary-preview {
  color: rgba(224, 224, 224, 0.7);
  font-style: italic;
  font-weight: 400;
}
</style>
